import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { getThemeClasses } from '../../utils/theme';

const LoadingSpinner = ({ size = 'md', message = 'Loading...' }) => {
  const { isDarkMode } = useTheme();
  const theme = getThemeClasses(isDarkMode);

  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div
        className={`${sizeClasses[size]} border-4 ${isDarkMode ? 'border-slate-700 border-t-blue-400' : 'border-blue-200 border-t-blue-600'} rounded-full animate-spin`}
      ></div>
      {message && (
        <p className={`mt-4 text-sm ${theme.textSecondary} font-medium`}>{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
